import React, { FC } from 'react';
import { windowService } from '../../../../utils/window.utils';
import { TMarketSelector } from '../../types/splashComponent.types';

const MarketSelector: FC<TMarketSelector> = ({ markets = [] }) => {
     // retaining the code if the cookie needs to be used in future
    // const context = useSitecoreContext();
    // const storeMartketSelection = (marketUrl: string) => {
    //     if (marketUrl) {
    //         documentService().cookie = `${COOKIE_NAME_SELECTED_MARKET}=${marketUrl}; max-age=${COOKIE_MAX_AGE}; path=/; domain=${context?.sitecoreContext?.hostDomain}`;
    //     }
    // }

    const handleMarketSelection = (e: React.MouseEvent<HTMLAnchorElement>, marketId: string) => {
        e.preventDefault();
         // retaining the code if the cookie needs to be used in future
        // storeMartketSelection(marketId);
        windowService().location.replace(e.currentTarget?.href);
    }

    return (
        <ul className='splash-component-market-selector-list'>
            {markets?.map((market) => (
                <li key={market.id} className='splash-component-market-selector-list__item'>
                    {/* Use regular anchor tag to force page load via SSR */}
                    <a
                        href={market?.fields?.url?.value ?? ''}
                        onClick={(e) => handleMarketSelection(e, market.id)}
                        className="splash-component-market-selector-list__item-link"
                    >
                        {market?.fields?.title?.value ?? ''}
                    </a>
                </li>
            ))}
        </ul>
    )
};

export default MarketSelector;
